"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicalUploadLink = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const customer_entity_1 = require("../customers/customer.entity");
const medical_doc_entity_1 = require("./medical-doc.entity");
let MedicalUploadLink = class MedicalUploadLink {
};
exports.MedicalUploadLink = MedicalUploadLink;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], MedicalUploadLink.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => customer_entity_1.Customer, { onDelete: 'CASCADE' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof customer_entity_1.Customer !== "undefined" && customer_entity_1.Customer) === "function" ? _a : Object)
], MedicalUploadLink.prototype, "customer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'customerId' }),
    tslib_1.__metadata("design:type", Number)
], MedicalUploadLink.prototype, "customerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Index)({ unique: true }),
    (0, typeorm_1.Column)({ length: 64 }),
    tslib_1.__metadata("design:type", String)
], MedicalUploadLink.prototype, "token", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], MedicalUploadLink.prototype, "expiresAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: medical_doc_entity_1.DocType, default: medical_doc_entity_1.DocType.OTHER }),
    tslib_1.__metadata("design:type", typeof (_c = typeof medical_doc_entity_1.DocType !== "undefined" && medical_doc_entity_1.DocType) === "function" ? _c : Object)
], MedicalUploadLink.prototype, "requestedDocType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], MedicalUploadLink.prototype, "notes", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'json', nullable: true }),
    tslib_1.__metadata("design:type", Array)
], MedicalUploadLink.prototype, "files", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], MedicalUploadLink.prototype, "uploadComplete", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], MedicalUploadLink.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], MedicalUploadLink.prototype, "updatedAt", void 0);
exports.MedicalUploadLink = MedicalUploadLink = tslib_1.__decorate([
    (0, typeorm_1.Entity)('medical_upload_links')
], MedicalUploadLink);
